import { render, staticRenderFns } from "./MsgElementKeywords.vue?vue&type=template&id=56f44c00&scoped=true"
import script from "./MsgElementKeywords.vue?vue&type=script&lang=js"
export * from "./MsgElementKeywords.vue?vue&type=script&lang=js"
import style0 from "./MsgElementKeywords.vue?vue&type=style&index=0&id=56f44c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f44c00",
  null
  
)

export default component.exports